import React from "react";
import { FieldControl } from "react-reactive-form";

const LaySummaryButtonGroup = ({
  questionName,
  globalId,
  choices,
  disabled = false,
}) => {
  return (
    <div data-field-name={questionName}>
      {choices.map((choice, i) => (
        <FieldControl
          key={`${questionName}-${i}_${globalId}`}
          name={questionName}
          render={({ handler }) => (
            <>
              <input
                className={`btn-check ${disabled ? "disabled" : ""}`}
                id={`${questionName}-${i}_${globalId}`}
                disabled={disabled}
                {...handler("radio", `${choice.value}`)}
              />
              <label
                className={`btn btn-light ${disabled ? "disabled" : ""}`}
                htmlFor={`${questionName}-${i}_${globalId}`}>
                {choice.title}
              </label>
            </>
          )}
        />
      ))}
    </div>
  );
};

export default LaySummaryButtonGroup;
